import { render, staticRenderFns } from "./angleUp.vue?vue&type=template&id=527dbec0&"
import script from "./angleUp.vue?vue&type=script&lang=ts&"
export * from "./angleUp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports